export { default, Disclaimer } from './Disclaimer';
